<template>
  <a-select
    v-model="defaultValue"
    @search="search"
    showSearch
    :filter-option="false"
    @popupScroll="scroll"
    @select="select"
    :dropdownMatchSelectWidth="false"
    style="min-width:108px"
  >
    <a-icon slot="suffixIcon" type="search" />
    <a-select-option
      v-for="(item, index) in seriesArr"
      :key="item.objectId + index"
      :value="item.objectId"
    >
        {{item.name}}
      </a-select-option>
    <a-select-option v-if="showLoading" disabled :key="seriesArr.length + 1">
      <div class="spin" style="width:100%">
        <a-spin style="margin:auto" />
      </div>
    </a-select-option>
  </a-select>
</template>
<script>
// import Bus from '../../assets/js/eventBus'
export default {
  data () {
    return {
      seriesArr: [
        {
          name: '全部战区',
          type: 'all',
          objectId: 'all'
        }
      ],
      count: 0,
      data: {
        room: ''
      },
      showLoading: false, // 是否显示加载
      more: true, // 是否还有更多
      searchValue: '',
      defaultValue: 'all',
      defaultUser: {}
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      await this.getSeriesArr()
    },
    search (a) {
      this.more = true
      this.showLoading = false
      this.count = 0
      this.seriesArr = []
      this.searchValue = a
      this.init()
    },
    async getSeriesArr () {
      let where = {
        isDelete: {
          $ne: true
        },
        level: '1'
      }
      if (this.searchValue) {
        where = {
          level: '1',
          isDelete: {
            $ne: true
          },
          name: {
            $regex: `(?i)${this.searchValue}`
          }
        }
      }
      let { data: res } = await this.$tkParse.get('/classes/department', {
        params: {
          limit: 10,
          skip: 10 * this.count,
          where: where
        }
      })
      console.log(res)
      if (res.results.length < 10) {
        this.more = false
      } else {
        this.more = true
      }
      this.seriesArr = [...this.seriesArr, ...res.results]
      this.showLoading = false
      this.$forceUpdate()
    },
    scroll (e) {
      const { target } = e
      const { scrollHeight, clientHeight, scrollTop } = target
      if (scrollHeight - clientHeight - scrollTop === 0 && this.more) {
        this.loadMore()
      }
    },
    async loadMore () {
      if (!this.showLoading) {
        this.showLoading = true
        this.count++
        await this.getSeriesArr()
        this.showLoading = false
      }
    },
    select (value) {
      this.$emit('select', value)
    }
  }
}
</script>

<style>
.spin {
  margin: auto;
  cursor: not-allowed;
  text-align: center;
  /* pointer-events: none; */
}
</style>
